<template>
    <div class="home-container">
        <Header v-if="isContent"></Header>
        <!--管理员内容页，排除掉登录页面和首页-->
        <ManagerHome v-if="this.$route.path.startsWith('/manager/') && this.$route.path !== '/m/login' ">
        </ManagerHome>
        <!--数据展示页，只有路由正确才显示-->
        <!-- 管理端不显示这个router-view -->
        <router-view v-if="!this.$route.path.startsWith('/manager/')  "/>
        <Footer v-if="isContent"></Footer>
    </div>
</template>
<script>
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import ManagerHome from "@/views/manager/home.vue";

export default {
    name: "app1",
    components: {
        Header, Footer, ManagerHome
    },
    computed: {
        isContent() {
            if(this.$route.path ==="/"){
                return false;
            }
            return !(this.$route.path.startsWith('/manager/')||this.$route.path.startsWith('/dataShow')||this.$route.path.startsWith('/m'));
        }
    }
}
</script>
<style></style>